<template>
  <div class="group-setup">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-form ref="supplierform" v-model="valid" v-if="!loading">
      <v-card>
        <v-container class="pa-6">
          <HeaderDividerBlock
            headerText="Supplier Details"
          ></HeaderDividerBlock>
          <v-row>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Supplier Full Name*</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.name"
                placeholder="Enter Supplier Full Name*"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Supplier Category*</p>
              </v-col>
              <v-autocomplete
                v-model="formData.supplier_category_id"
                :items="supplierCategoryOptions"
                item-text="name"
                item-value="id"
                placeholder="Select Supplier Category*"
                dense
                outlined
                clearable
                @change="onSupplierCategoryChange"
              ></v-autocomplete>
            </v-col>

            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Company Reg No</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.company_reg_no"
                placeholder="Enter Company Reg No"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Company Vat No</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.vat_reg_no"
                placeholder="Enter Company Vat No"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Company NBT No</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.nbt_reg_no"
                placeholder="Enter Company NBT No"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Credit Limit</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.credit_limit"
                placeholder="Credit Limit"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Credit Period Days</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.credit_period_days"
                placeholder="Enter Credit Period Days"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Status</p>
              </v-col>
              <v-select
                v-model="formData.status"
                :items="statuses"
                item-text="text"
                item-value="value"
                placeholder="Select Status"
                dense
                outlined
                clearable
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Remarks</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.remarks"
                placeholder="Enter Remarks"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <FileUpload @changeFile="changeFile" :type="'image/*'" />
              <v-col class="mt-2">
                <ImageBox :imageUrl="imageUrl || ''" />
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card>
        <v-container class="pa-6">
          <HeaderDividerBlock headerText="Contact Person"></HeaderDividerBlock>

          <v-row>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Contact Person*</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.contact_person"
                required
                placeholder="Enter Contact Person*"
              ></v-text-field>
            </v-col>

            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Phone</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.phone"
                placeholder="Enter Phone"
              ></v-text-field>
            </v-col>

            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Mobile</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.mobile"
                placeholder="Enter Mobile"
              ></v-text-field>
            </v-col>

            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Email</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.email"
                placeholder="Enter Email"
                :rules="emailRules"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card>
        <v-container class="pa-6">
          <HeaderDividerBlock headerText="Adress Details"></HeaderDividerBlock>

          <v-row>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Address</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.address"
                placeholder="Enter Address"
              ></v-text-field>
            </v-col>

            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">City</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="formData.city"
                placeholder="Enter City"
              ></v-text-field>
            </v-col>

            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Country</p>
              </v-col>
              <v-autocomplete
                v-model="formData.country_id"
                :items="countries"
                item-text="country_name"
                item-value="id"
                placeholder="Select Country"
                dense
                outlined
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col cols="12" md="9" xs="6"> </v-col>
            <v-col cols="12" md="3" xs="6">
              <v-btn
                v-if="
                  (mode === 'edit' && hasPermission('Suppliers.edit')) ||
                    (mode != 'edit' && hasPermission('Suppliers.create'))
                "
                large
                color="#00B3FF"
                dark
                depressed
                :disabled="loading"
                block
                @click="submitForm()"
              >
                {{ mode === "edit" ? "Update Supplier" : "Create Supplier" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="supplierCategoryDialog" max-width="400px">
        <v-card>
          <v-card-title>
            <span class="headline">Add New Supplier Category</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="newSupplierCategory.name"
              label="Category Name"
              required
              outlined
              dense
            />
            <v-select
              v-model="newSupplierCategory.status"
              :items="['ACTIVE', 'INACTIVE']"
              label="Status"
              outlined
              dense
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="createSupplierCategory">Save</v-btn>
            <v-btn text @click="supplierCategoryDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <Snackbars
        :text="successMsg"
        :snackbar="snackbar"
        :color="'success'"
        @classSnackbar="closeSnackbar"
      />
      <Snackbars
        :text="'Validation error please scroll up'"
        :snackbar="snackbarError"
        :color="'red'"
        @classSnackbar="closeSnackbar"
      />
    </v-form>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { SupplierService } from "@/services/supplier-service.js";
import { CommonService } from "@/services/common-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import FileUpload from "@/components/shared/FileUpload";
import ImageBox from "@/components/shared/ImageBox";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "CreateSupplier",
  components: { Alert, Snackbars, HeaderDividerBlock, FileUpload, ImageBox },

  props: {
    formData: { type: Object, required: true },
    mode: { type: String, required: true },
    id: { type: String, required: false },
    proploading: { type: Boolean, required: true },
  },

  data: () => ({
    imageUrl: null,
    rules: {
      required: (value) => !!value || "This field is required.",
    },
    valid: false,
    countries: [],
    supplier_catergories: [],
    types: [],
    snackbar: false,
    snackbarError: false,
    successMsg: "Supplier has been created successfully",
    errors: null,
    loading: false,
    statuses: [
      { text: "Active", value: "ACTIVE" },
      { text: "Inactive", value: "INACTIVE" },
    ],
    supplierCategoryDialog: false,
    newSupplierCategory: {
      name: "",
      status: "ACTIVE",
    },
    phoneRules: [
      (v) =>
        !v || /^\d{10}$/.test(v) || "Phone number must be exactly 10 digits",
    ],
    emailRules: [
      (v) =>
        !v ||
        /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) ||
        "E-mail must be valid",
    ],
  }),

  mounted() {
    this.getSupplierCategories();
    this.getCountries();
    if (this.mode === "edit") {
      this.imageUrl = `http://localhost:8000/storage/${this.formData.profile_image}`;
    }
  },

  computed: {
    supplierCategoryOptions() {
      return [
        { id: "add_new", name: "➕ Add New Category" },
        ...this.supplier_catergories,
      ];
    },
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },

  methods: {
    changeFile(event) {
      if (event) {
        this.imageUrl = URL.createObjectURL(event);
        this.formData.profile_image = event;
      } else {
        this.imageUrl = null;
        this.formData.profile_image = null;
      }
    },

    onSupplierCategoryChange(val) {
      if (val === "add_new") {
        this.supplierCategoryDialog = true;
        this.formData.supplier_category_id = null;
      }
    },
    async createSupplierCategory() {
      try {
        const response = await SupplierService.createCategory(
          this.newSupplierCategory
        );
        if (response.data && response.data.data) {
          this.supplier_catergories.unshift(response.data.data);
          this.formData.supplier_category_id = response.data.data.id;
          this.supplierCategoryDialog = false;
          this.newSupplierCategory = { name: "", status: "ACTIVE" };
        }
      } catch (err) {
        this.errors = err.response?.data || "Error creating category.";
      }
    },

    async submitForm() {
      const isvalid = this.$refs.supplierform.validate();
      if (!isvalid) return;
      this.loading = true;

      Object.keys(this.formData).forEach((key) => {
        if (this.formData[key] === null) {
          this.formData[key] = "";
        }
      });

      try {
        const formData = new FormData();
        for (const key in this.formData) {
          if (key === "profile_image") {
            if (this.formData[key] instanceof File) {
              formData.append("profile_image", this.formData[key]);
            }
          } else {
            formData.append(key, this.formData[key]);
          }
        }

        if (this.mode === "create") {
          await SupplierService.createSupplier(formData);
        } else {
          await SupplierService.updateSupplier(this.id, formData);
        }
        this.$router.push({ name: "Suppliers" });
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
        console.log(this.errors);
      } finally {
        this.loading = false;
      }
    },

    async getSupplierCategories() {
      try {
        const SupplierCatergoriesResponse = await SupplierService.getSupplierCatergories();
        this.supplier_catergories = SupplierCatergoriesResponse.data;
      } catch (error) {
        console.error("Error fetching Supplier Categories:", error);
      }
    },

    async getCountries() {
      try {
        const countriesResponse = await CommonService.getCountries();
        this.countries = countriesResponse.data;
      } catch (error) {
        console.error("Error fetching Countries:", error);
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },
  },

  watch: {
    "formData.profile_image": function(newValue) {
      if (typeof newValue === "string") {
        this.imageUrl = `http://localhost:8000/storage/${newValue}`;
      }
    },
  },
};
</script>
